import { withSuspenseLazy } from '@metrika/ui-kit';

export const RiskLazy = withSuspenseLazy(() => import('./routes'));
